import { Button, Flex, Heading, Spinner, Text } from '@chakra-ui/react';
import { SimpleContact } from '@texas/api/endpoints/contactsApi';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddVariantSupplierContact } from './AddVariantSupplierContact';
import { NewSupplierContactForm } from './NewSupplierContactForm';

export function AddVariantSupplierContactPanel({
  supplierId,
  contacts,
  loading,
  selectedIds,
  onChange,
  onContactCreated,
}: {
  supplierId: number;
  contacts: SimpleContact[];
  loading: boolean;
  selectedIds: number[];
  onChange: (ids: number[]) => void;
  onContactCreated: (contact: SimpleContact) => void;
}) {
  const { t } = useTranslation();
  const [creatingContact, setCreatingContact] = useState(false);

  const toggle = (id: number) => {
    onChange(
      selectedIds.includes(id)
        ? selectedIds.filter((selectedId) => selectedId !== id)
        : [...selectedIds, id],
    );
  };

  return (
    <Flex
      direction="column"
      flexShrink={0}
      gap={4}
      w={{ base: 'full', lg: '350px' }}
    >
      <Flex align="center" justify="space-between">
        <Heading fontSize="xl">
          {t('variant.supplier.addModal.contacts')}
        </Heading>
        {!creatingContact && (
          <Button
            variant="entityDirectoryMenu"
            color="entityDirectory.primaryBackground"
            fontSize="sm"
            h="auto"
            onClick={() => setCreatingContact(true)}
          >
            {t('variant.supplier.addModal.newContactAction')}
          </Button>
        )}
      </Flex>
      <Text color="entityDirectory.mutedText" fontSize="sm">
        {t('variant.supplier.addModal.contactsDescription')}
      </Text>
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <Flex direction="column" gap={2}>
          {contacts.map((contact) => {
            const selected = selectedIds.includes(contact.id);
            return (
              <AddVariantSupplierContact
                key={contact.id}
                contact={contact}
                selected={selected}
                onChange={() => toggle(contact.id)}
              />
            );
          })}
          {contacts.length === 0 && (
            <Text color="entityDirectory.mutedText" fontSize="sm">
              {t('variant.supplier.addModal.noContacts')}
            </Text>
          )}
        </Flex>
      )}
      {creatingContact && (
        <NewSupplierContactForm
          supplierId={supplierId}
          onCancel={() => setCreatingContact(false)}
          onCreated={(contact) => {
            onContactCreated(contact);
            setCreatingContact(false);
          }}
        />
      )}
    </Flex>
  );
}
